import type { FSC, SCNode } from "../engines/renderingEngine/fsc.types";
import { LineNode } from "../engines/renderingEngine/primitiveNodes";

type LineNodeProps = {
  key: string;
  style?: Parameters<typeof LineNode>[0]["style"];
  sourceNodeId: string;
  targetNodeId: string;
  startNodeHash: string;
  endNodeHash: string;
  flowLineType: "swimlane" | "step";
  isSelected: boolean;
  isHovered: boolean;
};
export const Line: FSC<LineNodeProps> = ({ key, style, ...props }): SCNode =>
  LineNode({
    key,
    startNodeId: props.sourceNodeId,
    endNodeId: props.targetNodeId,
    startNodeHash: props.startNodeHash,
    endNodeHash: props.endNodeHash,
    flowLineType: props.flowLineType,
    isSelected: props.isSelected,
    isHovered: props.isHovered,
    style: { ...lineNodeDefaultStyles, ...style }
  });

const lineNodeDefaultStyles: Parameters<typeof LineNode>[0]["style"] = {
  color: "#000000",
  width: 2
};
